import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/pro-solid-svg-icons/faFilter';

import withComponentName from '../../../decorators/withComponentName';
import PlayVideoComponent from '../../PlayVideoComponent';

import './styles.css';

export const TrendingHead = ({
  trendingExpand, onExpandChange,
}) => {
  const toggleTrending = () => {
    onExpandChange('trendingExpand', !trendingExpand);
    onExpandChange('personalisationExpand', false);

    if (trendingExpand) {
      document.activeElement.blur();
    }
  };

  return (
    <div className="TrendingHead">
      <span className="TrendingHead__header">
        News and Research
        <PlayVideoComponent
          videoLink="https://cityfalcon.wistia.com/medias/be7nogrmi6"
          videoLinkMobile="https://cityfalcon.wistia.com/medias/u1x1niau9u"
        />
      </span>
      <div className="TrendingHead__btns">
        <button
          type="button"
          className={`TrendingHead__btn--filters ${trendingExpand && 'expanded'}`}
          onClick={toggleTrending}
        >
          <FontAwesomeIcon icon={faFilter} />
          <span className="btn--trending">Trending Filters</span>
          <span className="btn--topic">Topic Filters</span>
        </button>
      </div>
    </div>
  );
};

export default withComponentName(TrendingHead);
